import React, { useState, useEffect, useRef } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import importAllImg from "../helpers/import-all-imgs";
import {useIntl} from "react-intl";
import {useNavigate} from "react-router-dom";


const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));

function Footer({toggleLang}) {

  const navigate = useNavigate();

  const { formatMessage } = useIntl();

  const fm = id => formatMessage({id});
  return (
    <div className='bg-[#354402] pb-5 md:pb-12 py-0 md:py-12 px-8 md:px-10 relative'>
      {/* Mobile Top Image */}
      <div className='flex justify-center -mb-2 md:hidden'>
        <img
          src={imgs['Group 3012.png']}
          alt="Footer Logo"
          className='w-auto h-auto'
        />
      </div>

      <div className='max-w-7xl mx-auto'>
        {/* Main Content - Two Columns on Desktop, Stacked on Mobile */}
        <div className='flex flex-col-reverse md:flex-row md:gap-[200px] mb-0 md:mb-8'>
          {/* Left Column - Navigation and Social */}
          <div className='flex flex-col mb-0 mt-5 md:mt-auto'>
            <div className='flex flex-col  gap-2 md:gap-6 mb-6'>
              <div
                onClick={() => navigate('/about')}
                className='text-white font-bold uppercase text-sm md:text-base cursor-pointer hover:text-white transition-colors'
              >
                {fm('ABOUT US')}
              </div>
              <div
                onClick={() => navigate('/blog')}
                className='text-white font-bold uppercase text-sm md:text-base cursor-pointer hover:text-white transition-colors'
              >
                {fm('BLOG')}
              </div>
              <div
                onClick={() => navigate('/contact')}
                className='text-white font-bold uppercase text-sm md:text-base cursor-pointer hover:text-white transition-colors'
              >
                {fm('CONTACT US')}
              </div>
            </div>

            {/* Social Media Icons */}
            <div className='flex justify-center md:justify-start gap-6 md:gap-8'>
              <img
                src={imgs['Group 29981.svg']}
                onClick={() => window.open('https://www.facebook.com/NguyenPhuongFamily')}
                className='cursor-pointer hover:opacity-80 transition-opacity w-6 h-6'
                alt="Facebook"
              />
              <img
                src={imgs['Group 29961.svg']}
                onClick={() => window.open('https://medium.com/@familynguyenphuong')}
                className='cursor-pointer hover:opacity-80 transition-opacity w-6 h-6'
                alt="Medium"
              />
              <img
                src={imgs['Group 29971.svg']}
                onClick={() => window.open('https://www.linkedin.com/company/77767320/')}
                className='cursor-pointer hover:opacity-80 transition-opacity w-6 h-6'
                alt="LinkedIn"
              />
              <a href="mailto:familynguyenphuong@gmail.com">
                <img
                  src={imgs['Group 29991.svg']}
                  className='cursor-pointer hover:opacity-80 transition-opacity w-6 h-6'
                  alt="Email"
                />
              </a>
            </div>
          </div>

          {/* Right Column - Service Focus Areas */}
          <div className='flex flex-col'>
            <div className='text-[#BBC1A2] font-bold uppercase text-sm md:text-base mb-2 md:mb-4'>
              {fm('OUR SERVICE FOCUS AREAS')}
            </div>
            <div className='flex flex-col gap-3'>
              <div
                onClick={() => navigate('/ourservice/innertransformation')}
                className='text-white font-bold text-sm md:text-base cursor-pointer hover:text-white transition-colors'
              >
                {fm('INNER TRANSFORMATION')}
              </div>
              <div
                onClick={() => navigate('/ourservice/education')}
                className='text-white font-bold text-sm md:text-base cursor-pointer hover:text-white transition-colors'
              >
                {fm('Education For All')}
              </div>
              <div
                onClick={() => navigate('/ourservice/communities')}
                className='text-white font-bold text-sm md:text-base cursor-pointer hover:text-white transition-colors'
              >
                {fm('THRIVING COMMUNITIES')}
              </div>
              <div
                onClick={() => navigate('/ourservice/changemakers')}
                className='text-white font-bold text-sm md:text-base cursor-pointer hover:text-white transition-colors'
              >
                {fm('PLATFORM FOR CHANGEMAKERS')}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section - Copyright and Privacy */}
        <div className='flex flex-col md:flex-row  justify-between items-center gap-4 pt-6 md:w-[70%]'>
          <div className='text-white text-xs md:text-sm text-center md:text-left'>
            {fm('© 2026. All rights reserved Nguyễn-Phương Family Foundation') }
          </div>
          <div
            onClick={() => navigate('/privacy-policy')}
            className='text-white text-xs md:text-sm cursor-pointer hover:text-white transition-colors text-center md:text-left'
          >
            {fm('Privacy Policy')}
          </div>
        </div>
      </div>

      {/* Right Side Graphic - Desktop Only */}
      <div className='absolute right-0 top-0 bottom-0 hidden md:block pointer-events-none'>
        <img
          src={imgs['Group 30012.svg']}
          alt="Footer Graphic"
          className='h-full w-auto'
        />
      </div>
    </div>
  )
}


export default Footer;
